import React, { FC } from 'react'
import { useLanguage } from '@moonpig/web-core-stores'
import { formatPrice } from '@moonpig/web-core-utils'
import { Flex, Text } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { useLocaleText } from './FromPrice.locale'

const StyledFlex = styled(Flex)`
  flex-direction: column;
  align-items: center;
  ${s({
    border: 2,
    borderRadius: 8,
    borderColor: 'colorBackground07',
    width: '100%',
    py: 4,
    bgcolor: 'colorBackground01',
  })}
`

export const FromPrice: FC<{
  priceCentAmount: number
  currencyCode: string
  fractionDigits: number
  minimumQuantity?: number
  isFrictionlessFlowEnabled?: boolean
}> = ({
  priceCentAmount,
  currencyCode,
  fractionDigits,
  minimumQuantity,
  isFrictionlessFlowEnabled = false,
}) => {
  const localise = useLocaleText()
  const language = useLanguage()

  const formattedMasterVariantPrice = formatPrice(
    priceCentAmount,
    fractionDigits,
    currencyCode,
    minimumQuantity,
    language,
  )

  if (isFrictionlessFlowEnabled) {
    return (
      <StyledFlex>
        <Text
          typography={{ xs: 'typeMobileDisplay03', md: 'typeDesktopDisplay05' }}
          color={'colorTextLabel'}
        >
          {localise('from_price.card_from_frictionless_flow')}{' '}
          {formattedMasterVariantPrice}
        </Text>
        <Text
          typography={{
            xs: 'typeMobileBodyCaption',
            md: 'typeBodyCaption',
          }}
          color={'colorTextLabel'}
        >
          {localise('from_price.copy_frictionless_flow')}
        </Text>
      </StyledFlex>
    )
  }

  return (
    <Text
      typography={{ xs: 'typeMobileDisplay03', md: 'typeDesktopDisplay05' }}
      color={'colorTextAlternate'}
    >
      {localise('from_price.copy')} {formattedMasterVariantPrice}
    </Text>
  )
}
